module.exports = __webpack_public_path__ + "static/media/arya.dc7c0b4e.jpeg";